import React, { useState } from "react";

import PlusIcon from "@uui/Plus";

import { Button as MuiButton, Collapse, Typography } from "@mui/material";

import Stack from "@rui/Stack";

import { MessageInput } from "./styles";

const AddAMessage = ({ onChange }: { onChange: (value: string) => void }) => {
  const [showMessageInput, setShowMessageInput] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <>
      <Collapse in={!showMessageInput}>
        <MuiButton
          startIcon={<PlusIcon />}
          onClick={() => setShowMessageInput(true)}
          variant="text"
          sx={{ color: "shades.neutral.600" }}
        >
          Add a message
        </MuiButton>
      </Collapse>
      <Collapse in={showMessageInput}>
        <Stack spacing={0.5}>
          <Typography variant="bodyPrimaryMed" color="shades.neutral.800">
            Add a message
          </Typography>
          <MessageInput onChange={handleChange} />
        </Stack>
      </Collapse>
    </>
  );
};

export default AddAMessage;
